module.exports = __webpack_public_path__ + "static/media/magic_rule_star.45302e6f.png";